import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '../../../../spacesPlatform/utils/actionParams';

export interface IPerformExtractEncryptionActionOnFlowsRequestParams extends IMultipleIdsParams {
  type: string;
}

export class PerformExtractEncryptionActionOnFlowsRequest extends Request<IPerformExtractEncryptionActionOnFlowsRequestParams, IResult> {
  constructor(ids: string[], type: string) {
    super('performExtractEncryptionActionOnFlows', {
      ids: ids,
      type: type
    });
  }
}
